import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-import-progress',
  template: require('./import.progress.component.html')
})
export class ImportProgressComponent {
  @Input() percentage: number;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
